import { IApplicationState } from '../../types/redux';
import { selectOffer } from '../offers';

export const selectNewbuildingHouseByOfferId = (id: number) => (state: IApplicationState) => {
  const { newbuildingHouse } = selectOffer(id)(state);

  return newbuildingHouse;
};
